<template>
    <v-card min-width="20vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p>{{ $t('firstMessage') }} <b>{{ brokerAccount.type }}</b> {{ $t('secondMessage') }} <b>{{ brokerAccount.broker.name }}</b>?</p>
            <v-btn @click="deleteBrokerAccount">{{ $t('btnDelete') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex';
    import Repository from '../../../repositories/brokerAccount';
    export default {
        name: "DeleteBrokerAccount",
        props: {
            brokerAccount: Object,
        },
        methods: {
            ...mapMutations(['setBrokerAccounts']),
            async deleteBrokerAccount() {
                await Repository.deleteBrokerAccount(this.brokerAccount.id).then((response) => {
                    if(response.status < 450) {
                        if(response.data) {
                            alert(this.$t('removedAlert'));
                            Repository.allBrokerAccountsOfUser().then((response) => {
                                this.setBrokerAccounts(response.data);
                            });
                        }
                        else
                            alert(this.$t('cantRemovedAlert'));
                    }
                }).catch((error)=>{
                    // eslint-disable-next-line no-console
                    console.log(`S: ${error.response.status}, M: ${error.response.message}`);
                });
                this.$emit('closeWindow');
            },
            closeWindow() {
                this.$emit('closeWindow');
            }
        }
    }
</script>

<i18n>
{
  "en": {
    "title": "Delete Broker Account",
    "firstMessage": "Are you sure to delete the",
    "secondMessage": "account related with",
    "btnDelete": "Yes, delete it",
    "removedAlert": "Your broker account was removed!",
    "cantRemovedAlert": "You cannot delete the broker account.\nThere are trades registered with this broker account in the journal. If you want to delete it, you need to unsubscribe the account for all the trades."
  },
  "es": {
    "title": "Eliminar Cuenta de Broker",
    "firstMessage": "¿Estas seguro de eliminar la cuenta",
    "secondMessage": "relacionada con",
    "btnDelete": "Sí, eliminarla",
    "removedAlert": "¡Tu cuenta de broker fue eliminada!",
    "cantRemovedAlert": "No puedes eliminar tu cuenta de broker.\nExisten trades registrados con esta cuenta en la bitácora. Si deseas eliminarla, necesitas eliminar o desvincular los trades de esta cuenta."
  }
}
</i18n>

<style scoped>

</style>
